// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts
export const LegalDocumentManagementAreaId = 'legalDocumentManagement' as const
